/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserInfo { 
    Id: string;
    RoleId: string;
    RoleLevel: number;
    RoleName: string;
    CustomerId: string;
    CustomerName: string;
    Email: string;
}

